import { useEffect } from 'react';
import { Icon } from '@iconify/react';
import { Button } from '@/components/shadcn/button';
import { Card } from '@/components/shadcn/card';
import { notifyError, notifySuccess } from '@/utils/nativeHaptics';

interface PadelFeedbackDialogProps {
  open: boolean;
  icon: string;
  title: string;
  message: string;
  variant?: 'success' | 'error';
  onClose: () => void;
}

export default function PadelFeedbackDialog({
  open,
  icon,
  title,
  message,
  variant = 'success',
  onClose,
}: PadelFeedbackDialogProps) {
  useEffect(() => {
    if (!open) return;
    if (variant === 'error') notifyError();
    else notifySuccess();
  }, [open, variant]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 top-0 z-50 flex items-center justify-center bg-black/80 p-4 !mt-0"
      role="presentation"
      onClick={onClose}
    >
      <Card
        role="dialog"
        aria-modal="true"
        aria-labelledby="padel-feedback-title"
        className="w-full max-w-sm rounded-3xl border-0 p-6 text-center shadow-lg"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-[#FFF1EC] text-[#FC480D]">
          <Icon icon={icon} className="h-7 w-7" />
        </div>
        <h2 id="padel-feedback-title" className="text-lg font-extrabold text-[#0E1726]">
          {title}
        </h2>
        <p className="mt-2 text-sm text-gray-500">{message}</p>
        <Button
          type="button"
          className="mt-5 h-12 w-full rounded-full bg-[#FC480D] font-bold text-white hover:bg-[#D83B08]"
          onClick={onClose}
        >
          Mengerti
        </Button>
      </Card>
    </div>
  );
}
